import styled from '@emotion/styled';
import * as React from 'react';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

export const ProperBetLogo = observer(
    'ProperBetLogo',
    ({ className, onClick }: PropsType): JSX.Element => (
        <SvgElement
            className={className}
            height='32'
            onClick={onClick}
            viewBox='0 0 131 32'
            width='131'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M130.667 26.2801C130.667 27.79 129.443 29.0144 127.933 29.0144C126.423 29.0144 125.199 27.79 125.199 26.2801C125.199 24.7701 126.423 23.5457 127.933 23.5457C129.443 23.5457 130.667 24.7701 130.667 26.2801Z'
                fill='#2CC4A0'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M34.1414 2.98535C36.1939 2.98535 37.7519 3.5429 38.8164 4.65799C39.8821 5.77184 40.415 7.42348 40.415 9.61414V21.7149C40.415 24.003 39.8821 25.7682 38.8164 27.0116C37.7519 28.2537 36.1939 28.8742 34.1414 28.8742C32.0901 28.8742 30.5322 28.2488 29.4665 26.9968C28.4019 25.7435 27.8703 23.9833 27.8703 21.7149V9.61414C27.8703 7.42346 28.402 5.77184 29.4665 4.65799C30.5322 3.54291 32.0901 2.98536 34.1414 2.98535ZM34.171 7.66027C33.3236 7.66028 32.9006 8.30174 32.9005 9.58454V21.9813C32.9005 22.7103 32.9881 23.2617 33.1644 23.6367C33.3421 24.0117 33.6677 24.1992 34.1414 24.1992C34.5953 24.1992 34.9012 24.0018 35.0591 23.6071C35.217 23.2124 35.2959 22.661 35.2959 21.9517V9.52533C35.2959 8.97275 35.2219 8.52371 35.0739 8.17834C34.9259 7.833 34.6249 7.66027 34.171 7.66027Z'
                fill='#EDE8DC'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M6.71518 3.22219C8.74615 3.22219 10.1962 3.87841 11.0646 5.19086C11.933 6.50208 12.3671 8.41954 12.3671 10.9439C12.3671 13.4689 11.9823 15.3722 11.2126 16.6551C10.4429 17.9367 9.06191 18.5768 7.07043 18.5768H5.00068V28.6374H0V3.22219H6.71518ZM5.00068 13.9907H5.29418C5.90598 13.9907 6.35499 13.8784 6.64117 13.6527C6.92734 13.4257 7.11483 13.1001 7.20365 12.6757C7.29246 12.2514 7.33687 11.6445 7.33687 10.8551C7.33686 9.7912 7.21845 9.02206 6.98162 8.54839C6.74477 8.07477 6.27108 7.83789 5.56061 7.83789H5.00068V13.9907Z'
                fill='#EDE8DC'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M21.7754 3.22219C23.0169 3.22219 23.9784 3.50344 24.6592 4.0659C25.3401 4.62838 25.799 5.41783 26.0358 6.43424C26.2727 7.44941 26.3911 8.74519 26.3911 10.3222C26.3911 11.763 26.2036 12.8879 25.8286 13.6971C25.4536 14.505 24.8023 15.0663 23.8747 15.3821C24.6444 15.54 25.202 15.9248 25.5474 16.5367C25.8927 17.1485 26.0654 17.9767 26.0654 19.0209L26.0062 28.6374H21.0353V18.6952C21.0353 17.9866 20.8971 17.5333 20.6208 17.336C20.3445 17.1386 19.8418 17.0399 19.1134 17.0399V28.6374H13.9647V3.22219H21.7754ZM19.143 12.6313H20.3544C21.0649 12.6313 21.4201 11.8616 21.4201 10.3222C21.4201 9.65305 21.3905 9.15034 21.3313 8.81483C21.2721 8.47934 21.1636 8.24741 21.0057 8.11913C20.8478 7.99086 20.6208 7.92671 20.3248 7.92671H19.143V12.6313Z'
                fill='#EDE8DC'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M49.1716 3.22219C51.2026 3.22219 52.6526 3.87841 53.521 5.19086C54.3894 6.50208 54.8236 8.41955 54.8236 10.9439C54.8236 13.4689 54.4387 15.3722 53.669 16.6551C52.8993 17.9367 51.5184 18.5768 49.5269 18.5768H47.4571V28.6374H42.4565V3.22219H49.1716ZM47.4571 13.9907H47.7506C48.3624 13.9907 48.8114 13.8784 49.0976 13.6527C49.3838 13.4257 49.5713 13.1001 49.6601 12.6757C49.7489 12.2514 49.7933 11.6445 49.7933 10.8551C49.7933 9.7912 49.6749 9.02206 49.4381 8.54839C49.2012 8.07477 48.7275 7.83789 48.0171 7.83789H47.4571V13.9907Z'
                fill='#EDE8DC'
            />
            <path
                d='M66.5976 8.13394H61.5995V13.0754H66.3904V17.8689H61.5995V23.6959H66.9233V28.6374H56.4212V3.22219H66.5976V8.13394Z'
                fill='#EDE8DC'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M76.4214 3.22219C77.6629 3.22219 78.6244 3.50343 79.3053 4.0659C79.9862 4.62838 80.4451 5.41785 80.6819 6.43424C80.9188 7.44941 81.0372 8.7452 81.0372 10.3222C81.0372 11.7629 80.8497 12.8879 80.4747 13.6971C80.0997 14.505 79.4484 15.0663 78.5208 15.3821C79.2905 15.54 79.8481 15.9249 80.1935 16.5367C80.5388 17.1485 80.7115 17.9768 80.7115 19.0209L80.6523 28.6374H75.6813V18.6952C75.6812 17.9866 75.5431 17.5333 75.2668 17.336C74.9905 17.1386 74.4878 17.0399 73.7594 17.0399V28.6374H68.6108V3.22219H76.4214ZM73.789 12.6313H75.0004C75.7109 12.6313 76.0661 11.8616 76.0661 10.3222C76.0661 9.65305 76.0365 9.15034 75.9773 8.81483C75.9181 8.47935 75.8095 8.24741 75.6516 8.11913C75.4938 7.99086 75.2668 7.92671 74.9708 7.92671H73.789V12.6313Z'
                fill='#EDE8DC'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M96.5424 3.22219C98.3957 3.22219 99.7421 3.67612 100.581 4.58398C101.42 5.4906 101.839 6.96956 101.839 9.02206V10.1446C101.839 12.5721 100.971 14.0222 99.2339 14.494C100.3 14.7703 101.05 15.4117 101.484 16.4183C101.918 17.4248 102.135 18.7563 102.135 20.4123C102.135 23.1149 101.731 25.1613 100.921 26.5527C100.112 27.9429 98.6523 28.6374 96.5424 28.6374H89.6496V3.22219H96.5424ZM94.6205 24.14L95.1214 24.1696C96.4437 24.1696 97.1049 23.5392 97.1049 22.2773V19.1097C97.1049 18.3419 96.9914 17.7603 96.7644 17.3656C96.5374 16.9709 96.1378 16.7735 95.5654 16.7735H94.6205V24.14ZM94.6205 12.7794H95.6543C96.0884 12.7794 96.3845 12.6165 96.5424 12.2909C96.7003 11.9653 96.7792 11.5064 96.7792 10.9143V8.37077C96.7792 7.54189 96.4141 7.12739 95.6839 7.12739H94.6205V12.7794Z'
                fill='#EDE8DC'
            />
            <path
                d='M113.998 8.13394H109V13.0754H113.791V17.8689H109V23.6959H114.324V28.6374H103.821V3.22219H113.998V8.13394Z'
                fill='#EDE8DC'
            />
            <path
                d='M126.306 8.10433H123.289V28.6374H118.199V8.10433H115.182V3.22219H126.306V8.10433Z'
                fill='#EDE8DC'
            />
        </SvgElement>
    )
);
